/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Uno_Edu_Intro_Spaces_Chip2_AnswerInputs */



/**
* | output |
* | --- |
* | "Yes. A space can connect to sources like OneDrive, SharePoint, Google Drive, GitHub, and more. After connecting you choose what to sync, and the space stays ..." |
*
* @param {Uno_Edu_Intro_Spaces_Chip2_AnswerInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const uno_edu_intro_spaces_chip2_answer = /** @type {((inputs?: Uno_Edu_Intro_Spaces_Chip2_AnswerInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Uno_Edu_Intro_Spaces_Chip2_AnswerInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Ja. Ein Space kann Quellen wie OneDrive, SharePoint, Google Drive, GitHub und weitere verbinden. Nach dem Verbinden wählen Sie, was synchronisiert wird, und der Space bleibt aktuell.")
	return /** @type {LocalizedString} */ ("Yes. A space can connect to sources like OneDrive, SharePoint, Google Drive, GitHub, and more. After connecting you choose what to sync, and the space stays up to date.")
});